import UrqlClient from './client';
import * as Constants from './constants';
import Mutations from './mutations';
import Queries from './queries';
import Schemas from './schemas';
import * as Utils from './utils';

export {
  type GraphQLAnnotations,
  type GraphQLDetails,
  type GraphQLOperationKeyName,
  type GraphQLOperationKeyNameAction,
  type GraphQLRequestParams,
  type GraphQLSchema,
} from './types';

export const GraphQL = {
  UrqlClient,
  Queries,
  Mutations,
  Schemas,
  Constants,
  Utils,
};
